import Cookies from 'js-cookie'
import AccountService from "~/services/account";
import MessageService from "~/services/Message";

const app = {
  state: {
    moduleId: 'MODULE_WORKSPACE', // 当前模块ID
    // 侧边栏伸缩状态
    sidebar: {
      opened: !+Cookies.get('sidebarStatus')
    },
    globalMessages: [], // 全局消息列表
    msgNum: '', // 全局未读消息数量
    enableGlobalMessage: true,
  },
  mutations: {
    TOGGLE_SIDEBAR: state => {
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1)
      } else {
        Cookies.set('sidebarStatus', 0)
      }
      state.sidebar.opened = !state.sidebar.opened
    },
    SWITCH_TAB_ID: (state, id) => {
      state.moduleId = id;
    },

    GLOBAL_MESSAGES: (state, messages) => {
      state.globalMessages = messages;
    },

    MSG_NUM: (state, total) => {
      if (total > 0) {
        state.msgNum = total;
      } else {
        state.msgNum = '';
      }
    },

    ENABLE_GLOBAL_MESSAGE: (state, status) => {
      state.enableGlobalMessage = status
    }
  },
  actions: {

    ToggleSideBar: ({ commit }) => {
      commit('TOGGLE_SIDEBAR')
    },

    SwitchModuleId: (context, id) => {
      context.commit('SWITCH_TAB_ID', id);
    },

    getGlobalMessage({commit}) {
      return new Promise((resolve, reject) => {
        //加了个随机数参数，防止本地出现接口跨域问题
        MessageService.getMyUnreads({perPage: 1, random: Math.floor(Math.random()*(100000-5+1))+10000}).then(res => {
          if (res && res.code == 0) {

            // 这个暂时用不到
            //commit('GLOBAL_MESSAGES', res.data);
            commit('MSG_NUM', res._meta.totalCount);


            resolve(res);
          }
        }).catch(error => {
          reject(error)
        })
      })
    },

    setGlobalMessageState({commit}, status) {
      commit('ENABLE_GLOBAL_MESSAGE', status)
    }

  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js